export default __webpack_public_path__ + "static/media/cta-bg-1.0ebd75a5.jpeg";